import gql from 'graphql-tag'

export const READ_DATASET = gql`
  query ReadDataSet($dataSetID: ID!) {
    DataSet(id: $dataSetID) {
      name
      description
      id
      createdAt
      updatedAt
      author {
        id
        name
      }
      dataPoints
      charts {
        id
      }
    }
  }
`

export const READ_DATASETNAME = gql`
  query ReadDataSetName($dataName: String!, $userId: ID!) {
    allDataSets(filter: { name_contains: $dataName, author: { id: $userId } }) {
      name
      description
      id
      createdAt
      updatedAt
      author {
        id
        name
      }
      dataPoints
      charts {
        id
      }
    }
  }
`

export const READ_DATASETNAMEDESID = gql`
  query ReadDataSetNameDes($dataName: String!, $userId: ID!) {
    allDataSets(filter: { name_contains: $dataName, author: { id: $userId } }) {
      name
      description
      id
      createdAt
      updatedAt
      author {
        id
        name
      }
      dataPoints
      charts {
        id
      }
    }
  }
`

export const READ_DATASETNAMEDES = gql`
  query ReadDataSetNameDes($dataName: String!, $dataDescription: String!) {
    allDataSets(
      filter: {
        name_contains: $dataName
        description_contains: $dataDescription
      }
    ) {
      name
      description
      id
      createdAt
      updatedAt
      author {
        id
        name
      }
      dataPoints
      charts {
        id
      }
    }
  }
`

export const READ_DATASETS = gql`
  query ReadDataSets {
    allDataSets(orderBy: createdAt_DESC) {
      name
      description
      id
      createdAt
      updatedAt
      author {
        id
        name
      }
      dataPoints
      charts {
        id
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/dataset.js